import { createApp } from 'vue/dist/vue.esm-bundler';

import RosterState from '../../frontend/components/roster/RosterState.vue';
import AuthHeaderActions from '../../frontend/components/shared/AuthHeaderActions.vue';
import { initVueSentry } from '../sentry';

// Track the current app instance
let currentApp = null;

// Function to create and mount the helper app
const mountHelperApp = () => {
  const contentContainer = document.querySelector('.main > .content');

  if (!contentContainer) {
    return;
  }

  // If there's already an app mounted, unmount it first
  if (currentApp) {
    currentApp.unmount();
    currentApp = null;
  }

  // Ensure the header actions component exists in the template, so it can teleport
  // the locale switcher into header#breadcrumbs on auth pages.
  if (!contentContainer.querySelector('auth-header-actions')) {
    contentContainer.insertAdjacentHTML('beforeend', '<auth-header-actions></auth-header-actions>');
  }

  // Create new app
  const app = createApp();

  initVueSentry({ app, appName: 'helper' });

  app.component('RosterState', RosterState);
  app.component('AuthHeaderActions', AuthHeaderActions);

  // Mount the app
  currentApp = app;
  app.mount('.main > .content');
};

// Initialize helper app when DOM is ready
document.addEventListener('DOMContentLoaded', mountHelperApp);
